import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { ShareDataService } from '../../services/share-data.service';
@Component({
  selector: 'app-addendum-dialog',
  templateUrl: './addendum-dialog.component.html',
  styleUrls: ['./addendum-dialog.component.scss']
})
export class AddendumDialogComponent implements OnInit  {
  constructor(
    public dialogInfoRef: MatDialogRef<DialogComponent>,
    private shareService: ShareDataService
  ) {}
  ngOnInit(): void {
  }
  close(): void {
    this.dialogInfoRef.close();
  }
  onContinue(): void {
    this.dialogInfoRef.close();
  }
}